import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function DashboardCasting() {
  const { user } = useAuth();
  const [tab, setTab] = useState("shortlist");
  const [shortlist, setShortlist] = useState([]);
  const [enquiries, setEnquiries] = useState([]);
  const [calls, setCalls] = useState([]);
  const [newCall, setNewCall] = useState({ project: "", role: "", shoot_date: "", location: "", budget: "", usage: "", requirements: "", message: "" });

  const load = () => {
    api.get("/shortlist").then((r) => setShortlist(r.data));
    api.get("/enquiries/mine").then((r) => setEnquiries(r.data));
    api.get("/casting-calls").then((r) => setCalls(r.data));
  };
  useEffect(load, []);

  const postCall = async () => {
    try { await api.post("/casting-calls", newCall); toast.success("Casting call published."); load();
      setNewCall({ project: "", role: "", shoot_date: "", location: "", budget: "", usage: "", requirements: "", message: "" });
    } catch (e) { toast.error(e.response?.data?.detail || "Only casting professionals can post."); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B]">
      <Header />
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 py-12">
        <div className="sv-overline mb-3">Casting Dashboard</div>
        <h1 className="font-serif-hero text-4xl">Welcome, {user?.full_name}.</h1>

        <div className="mt-8 flex gap-2 flex-wrap">
          {[{ k: "shortlist", l: "Shortlist" }, { k: "enquiries", l: "Enquiries" }, { k: "calls", l: "Casting Calls" }, { k: "post", l: "Post New Call" }].map((t) => (
            <button key={t.k} onClick={() => setTab(t.k)} data-testid={`tab-${t.k}`}
              className={`px-5 py-2 rounded-full text-xs font-mono-label ${tab === t.k ? "bg-[#C5A059] text-[#0A0A0B]" : "bg-[#1A1A1F] border border-[#5A2E2E]"}`}>{t.l}</button>
          ))}
        </div>

        <div className="mt-8">
          {tab === "shortlist" && (
            <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
              {shortlist.length === 0 && <div className="text-sm text-[#8A8478]">No shortlisted talent yet. <Link to="/search" className="underline">Browse talent.</Link></div>}
              {shortlist.map((s) => <Link to={`/talent/${s.talent_id}`} key={s.talent_id} className="sv-card p-4 text-sm">View {s.talent_id.slice(-6)}</Link>)}
            </div>
          )}
          {tab === "enquiries" && (
            <div className="space-y-3">
              {enquiries.length === 0 && <div className="text-sm text-[#8A8478]">No enquiries sent yet.</div>}
              {enquiries.map((e) => (
                <div key={e.enquiry_id} className="sv-card p-5">
                  <div className="font-serif-editorial text-lg">{e.project} — {e.role}</div>
                  <div className="text-xs text-[#8A8478]">{e.location} · {e.shoot_date}</div>
                  <div className="text-sm mt-2">Status: <span className="font-mono-label text-[10px] text-[#C5A059]">{e.status}</span> {e.response && `· Response: ${e.response}`}</div>
                </div>
              ))}
            </div>
          )}
          {tab === "calls" && (
            <div className="grid md:grid-cols-2 gap-4">
              {calls.map((c) => (
                <div key={c.casting_id} className="sv-card p-5">
                  <div className="font-mono-label text-[10px] text-[#C5A059]">{c.location}</div>
                  <div className="font-serif-editorial text-xl">{c.project}</div>
                  <div className="text-sm text-[#CDC7BA]">{c.role}</div>
                  <div className="text-xs text-[#8A8478] mt-2">{c.requirements}</div>
                </div>
              ))}
            </div>
          )}
          {tab === "post" && (
            <div className="sv-card p-6 max-w-2xl grid gap-3">
              {["project", "role", "shoot_date", "location", "budget", "usage", "requirements"].map((f) => (
                <input key={f} placeholder={f.replace("_", " ")} value={newCall[f]} onChange={(e) => setNewCall({ ...newCall, [f]: e.target.value })}
                  className="px-4 py-3 border border-[#5A2E2E] rounded-lg outline-none focus:border-[#C5A059]" data-testid={`new-call-${f}`} />
              ))}
              <button onClick={postCall} data-testid="post-call" className="sv-btn-primary">Publish Casting Call</button>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
